import { Grid } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import BaseTable from "../../common/base-table/base-table";

function HotelRegulationsTable() {
    //general variables
    const { t } = useTranslation();
    const checkRateData = JSON.parse(sessionStorage.getItem("checkRateData"));
    const [hotelData, setHotelData] = useState(null);

    useEffect(() => {
        setHotelData(checkRateData);
    }, []);

    //table's columns
    const columns = useMemo(() => [
        {
            accessorKey: "title",
            header: " ",
            enableSorting: false,
            size: 30,
        },
        {
            accessorKey: "regulation",
            header: "قوانین هتل",
            enableSorting: false,
        },
    ]);

    //table's rows
    const [rows, setRows] = useState([]);
    useEffect(() => {
        setRows(
            [
                hotelData?.name && { title: t("hotelName"), regulation: hotelData?.name },
                hotelData?.address && { title: t("address"), regulation: hotelData?.address },
                hotelData?.offer && { title: t("offer"), regulation: hotelData?.offer },
                hotelData?.non_refundable !== undefined && { title: t("refundable"), regulation: hotelData?.non_refundable ? t("no") : t("yes") },
                hotelData?.policy?.times?.begin && { title: t("checkInTime"), regulation: `${t("from")} ${hotelData?.policy.times.begin}` },
                hotelData?.policy?.times?.check_out && { title: t("checkOutTime"), regulation: hotelData?.policy.times.check_out },
                hotelData?.policy?.fees?.mandatory || (hotelData?.policy?.fees?.optional && { title: t("feesAndCharges"), regulatio: "" }),
                hotelData?.policy?.fees?.mandatory && { title: t("mandatoryFees"), regulation: hotelData?.policy.fees.mandatory },
                hotelData?.policy?.fees?.optional && { title: t("optionalExtras"), regulation: hotelData.policy.fees.optional },
                hotelData?.extra_charge?.excluded && { title: t("extraCharges"), regulation: hotelData?.extra_charge?.excluded },
                hotelData?.rooms?.["1"]?.meal_type && { title: t("mealPlan"), regulation: hotelData?.rooms["1"].meal_type },
                hotelData?.cancellation_policies?.["1"]?.length > 0 && {
                    title: t("cancellationPolicy"),
                    regulation: hotelData?.cancellation_policies["1"].map((policy, index) => (
                        <div key={index}>
                            {t("cancellationFee")} {policy.amount} {hotelData?.fare.unit} {t("appliesFrom")}{" "}
                            {new Date(policy.from_date).toLocaleDateString()}
                        </div>
                    )),
                },
                hotelData?.policy?.instructions ||
                    hotelData?.policy?.special_instructions ||
                    (hotelData?.policy?.know_before_you_go && {
                        title: t("instructions"),
                        regulatio: "",
                    }),
                hotelData?.policy?.instructions && { title: t("instructions"), regulation: hotelData?.policy.instructions },
                hotelData?.policy?.special_instructions && { title: t("specialInstructions"), regulation: hotelData?.policy.special_instructions },
                hotelData?.policy?.know_before_you_go && { title: t("importantInformation"), regulation: hotelData?.policy.know_before_you_go },
                hotelData?.amenities?.length > 0 && { title: t("amenities"), regulation: hotelData?.amenities.join(", ") },
                hotelData?.remarks?.length > 0 && { title: t("remarks"), regulation: hotelData?.remarks.join(", ") },
                hotelData?.policy?.pet_attributes?.length > 0 && {
                    title: t("petPolicy"),
                    regulation: hotelData?.policy.pet_attributes.map((pet, index) => <div key={index}>{pet.name}</div>),
                },
                hotelData?.policy?.min_age && { title: t("minAge"), regulation: hotelData?.policy.min_age },
                hotelData?.policy?.child_policy_desc_fa && { title: t("childPolicy"), regulation: hotelData?.policy.child_policy_desc_fa },
            ].filter(row => row),
        );
    }, [hotelData]);

    return (
        <Grid container item xs={12}>
            <BaseTable columns={columns} rows={rows} details={false} action={false} rowBackground="var(--light-color)" />
        </Grid>
    );
}

export default HotelRegulationsTable;
